import useCurrentEventInfo from '@contexts/useCurrentEventInfo';
import useNotificationService from '@contexts/useNotificationService';
import useRsvpAndJoinEvent from '@hooks/useRsvpAndJoinEvent';
import { AuthFlowError, useAuthStore } from '@sunrise-ui/primitives';
import { useEffect } from 'react';
import { type HostJoinedVideoRoom } from '../services/NotificationService';

export default function useHostJoinListener() {
  const { currentUserId } = useAuthStore();
  const { notificationService } = useNotificationService();
  const { currentRoomId, currentEventId, ticketToken } = useCurrentEventInfo();
  const { joinRoomAsAttendee } = useRsvpAndJoinEvent(currentEventId);

  useEffect(() => {
    if (notificationService && currentEventId && currentRoomId && ticketToken) {
      const removeListener = notificationService.addListener(
        'HostJoinedVideoRoom',
        async (hostJoinedVideoRoom: HostJoinedVideoRoom) => {
          const isHost = hostJoinedVideoRoom.user_id === currentUserId;
          const hasIntentionToJoin =
            hostJoinedVideoRoom.event_id === currentEventId &&
            hostJoinedVideoRoom.room_id === currentRoomId;
          if (!isHost && hasIntentionToJoin) {
            try {
              void joinRoomAsAttendee(ticketToken);
            } catch (e) {
              if (e instanceof AuthFlowError) return;
            }
          }
        },
      );

      return () => {
        removeListener();
      };
    }
  }, [notificationService, currentUserId, currentRoomId, currentEventId]);
}
